import { App as CapApp } from "@capacitor/app";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const DeepLinkHandler = () => {
  const navigate = useNavigate();

  const handleAppUrlOpen = (data: { url: string }) => {
    const url = new URL(data.url);
    const path = url.pathname + url.search;

    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    CapApp.addListener("appUrlOpen", handleAppUrlOpen);

    return () => {
      CapApp.removeAllListeners();
    };
  }, [navigate]);

  return null;
};
